<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="$router.currentRoute.path == '/researcher/newArticle'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <b-tabs class="mb-3" pills vertical v-model="tabIndex">
        <div class="d-flex justify-content-center mt-3"></div>
        <b-tab :title="'سنجش شناسه مقاله'" active>
          <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <template v-slot:header>
              <h4 class="mb-0">سنجش شناسه مقاله</h4>
            </template>
            <b-form-group>
              <div class="d-flex" dir="ltr">
                <label
                  for="switch_1"
                  :class="
                    initial.initialObligation
                      ? 'ml-3 mb-0 done'
                      : 'ml-3 mb-0 required'
                  "
                >
                  اینجانب تعهد می کنم با مطالعه و آگاهی از
                  <b-button
                    id="downLoad"
                    title="دانلود تعهدات"
                    variant="link"
                    href="/researcher/rules/article/شیوه نامه مقالات.pdf"
                  >
                    <b-tooltip
                      placement="bottomleft"
                      target="downLoad"
                      triggers="hover"
                      variant="info"
                      >دانلود شیوه‌نامه</b-tooltip
                    >شیوه‌نامه حمایت از مقالات ستاد توسعه زیست فناوری </b-button
                  >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست در
                  سامانه اقدام می نمایم
                </label>
                <b-form-checkbox
                  id="switch_1"
                  v-model="initial.initialObligation"
                ></b-form-checkbox>
              </div>
            </b-form-group>
            <hr />
            <h3 class="text-primary mb-4">پژوهشگر گرامی</h3>

            <p>
              به ابزار حمایت از طرح‌های پژوهشی سامانه تقسیم کار ملی خوش آمدید.
              خواهشمندیم ابتدا به سوالات زیر پاسخ دهید:
            </p>
            <b-row class="border mb-2 pt-2" align-v="center">
              <i
                class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                aria-hidden="true"
              ></i>
              <p class="mt-2 ml-2 text-danger">
                پژوهشگر گرامی، ممکن است برخی DOIها در سامانه تعریف نشده باشند.
                در صورتی که از صحت DOI وارد شده خود مطمئن هستید، جهت ثبت حمایت
                مقاله با پشتیبانی ستاد زیست فناوری تماس بگیرید.
              </p>
            </b-row>
            <b-form-group label="لطفا شناسه دیجیتال مقاله را وارد کنید">
              <b-form-input trim type="text" v-model="doi" dir="ltr">
              </b-form-input>
            </b-form-group>
            <br />
            <div class="warningBox">
              <span>
                لطفا هنگام ثبت شناسه دیجیتال، اعداد بعد از "/https://doi.org" را
                وارد نمایید. </span
              ><br /><br />
              نمونه شناسه دیجیتال معتبر:
              <span dir="ltr" class="doiB"> 10.1016/S1474-4822(18)30404-6</span
              ><i
                class="fa fa-check fa-2x mr-2 text-success"
                aria-hidden="true"
                style="float: left"
              ></i
              ><br /><br />
              نمونه شناسه دیجیتال نامعتبر:
              <span dir="ltr" class="doiB"
                >doi.org/10.1016/S1474-4822(18)30404-6</span
              ><i
                class="fa fa-times fa-2x mr-2 text-danger"
                aria-hidden="true"
                style="float: left"
              ></i
              ><br /><br />
              نمونه شناسه دیجیتال نامعتبر:
              <span dir="ltr" class="doiB"
                >https://doi.org/10.1016/S1474-4822(18)30404-6</span
              ><i
                class="fa fa-times fa-2x mr-2 text-danger"
                aria-hidden="true"
                style="float: left"
              ></i
              ><br /><br />
              <span dir="ltr"
                >لطفا اگر شناسه دیجیتال خود را با فرمت صحیح وارد کرده و از درستی
                آن اطمینان دارید اما نمیتوانید مقاله خود را ثبت نمایید از طریق
                ستاد زیست فناوری ریاست جمهوری پیگیری نمایید</span
              >
            </div>
          </b-card>
        </b-tab>
        <b-tab disabled :title="'اطلاعات اصلی مقاله'"></b-tab>
        <b-tab disabled :title="'اطلاعات نویسنده مسئول مقاله'"></b-tab>
        <b-tab disabled :title="'مشخصات مقاله'"></b-tab>
        <b-tab disabled :title="'زمان‌بندی'"></b-tab>
        <b-tab disabled :title="'وجه تشویقی'"></b-tab>
        <b-tab disabled :title="'تعهدات'"></b-tab>
        <b-tab disabled :title="'مرور نهایی و ارسال'"></b-tab>
      </b-tabs>
      <div class="d-flex justify-content-center mt-3">
        <!-- NOTE (b-start) To begin the proposal registration process -->
        <b-button
          class="mx-1"
          variant="primary"
          @click="start()"
          :disabled="!doi"
          >آغاز فرآیند</b-button
        >
      </div>
    </b-card>
    <router-view></router-view>
    <v-dialog v-model="doiDialog" width="600">
      <v-card>
        <v-card-title>
          <h4 class="primary--text">اطلاعات مقاله انتخاب شده</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <span class="font-weight-bold h5">شناسه دیجیتال مقاله: </span>
              <span class="h6" dir="ltr">{{ doi }}</span></v-col
            >
          </v-row>
          <v-row>
            <v-col>
              <span class="font-weight-bold h5">عنوان مقاله: </span>
              <span class="h6">{{ doiDetails.title }} </span></v-col
            >
          </v-row>
          <v-row>
            <v-col>
              <span class="font-weight-bold h5">نویسندگان مقاله: </span>
              <ul class="p-2">
                <li v-for="(person, index) in doiDetails.author" :key="index">
                  {{ person.given + " " + person.family }}
                </li>
              </ul>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="font-weight-bold h5"> ناشر: </span>
              <span class="h6">{{ doiDetails.publisher }} hi</span></v-col
            >
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            @click="goToCompleteArticle()"
            :disabled="loading"
            class="primary"
            >تایید</v-btn
          >
          <v-btn class="error" @click="doiDialog = false">لغو</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time

export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
  },
  data() {
    return {
      infoo: "",
      moment: moment,
      show: false,
      busy: false,
      initial: {},
      doi: "",
      source: "",
      specs: {},
      colleaguesData: [],
      serviceItems: [],
      selectedColleague: "",
      executor: {},
      proposal: {},
      colleague: {},
      universities: [],
      otherUniversity: "",
      mehvars: [],
      otherMehvars: "",
      achievmentitems: [],
      tabIndex: 1,
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      isLoaded: true,
      doiDialog: false,
      doiDetails: {},
      loading: false,
    };
  },

  methods: {
    start() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/article/doi",
          { doi: this.doi },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.doiDetails = res.data;
          this.doiDialog = true;
          this.$bvModal.hide("loading");
          this.isLoaded = true;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    goToCompleteArticle() {
      this.loading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/article/new",
          {
            doi: this.doi,
            initialObligation: this.initial.initialObligation,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res2) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          this.loading = false;
          router.push("/researcher/completeArticle/" + res2.data);
        })
        .catch((err2) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          this.loading = false;
          this.toast(err2.response.data, "error");
        });
    },
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
.warningBox {
  background-color: rgb(212, 164, 245);
  border-radius: 10px;
  border: rgb(185, 124, 185) solid;
  padding: 15px;
  box-shadow: 3px 3px 10px rgb(194, 113, 201);
  max-width: 720px;
}
.doiB {
  background-color: white;
  float: left;
  padding: 6px;
  border-radius: 5px;
}
</style>
